import React from 'react'
import { createContainer } from '@dbk-legacy/muster/react'
import Spinner from '@dbk/ui-spinner';
import Text, { Small, Large, H1, H3 } from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import Modal from '@dbk/ui-modal';
import {Info} from '@dbk/ui-icons';
import {Checkbox, TextInput} from '@dbk/ui-forms';
import {Currency} from '../../components/common/number';
import format from 'date-fns/format';
import PaymentError from './payment-error'
import ConfirmationModal from './payment-confirmation-modal'
import CancelModal from './payment-cancel-modal'
import paymentStatusModalNew from './payment-status-screen'
import { ROUTES, EBANKINGWEBUK, EBANKINGWEBLUX, RM_REGION_UK, ALL_CHARGES_EN, ALL_CHARGES_DE,  RM_REGION_CH, EBANKINGWEB, RM_REGION, PALETTE, MULTISIGN_PAYMENT_STATUS, PAYMENT_STATUS, SEPA_PAYMENT_TYPE } from '../../constants';
import TransactionSecurityAdvice from '../../../@extension/CH/src/scenes/portfolio/transactions-global/transaction-security-advice/transaction-security-advice';
import styles from './payment-summary.styles';
import { ErrorIcon, WarningDarkIcon, AttentionDarkIcon } from '../../components/common/icons';
import { PAYMENT_TYPE, POPOVER_ICON_SIZE, VOP_VALIDATE_CODES} from './constant';
import envConfig from '../../../db-env-build';
import labelForPFid from '../../utils/portfolio-number-aria-label';
import { View } from '@dbk/ui-react-utils';
import Helptext from './vop/Helptext';
import HelptextDescription from './vop/HelptextDescription';
import { FormattedMessage } from '@dbk/format';
import isEnterorSpaceKeyPressed from '../../utils/isEnterorSpaceKeyPressed';
import { isVopAllowed } from '../../utils/featureCheck';

import { MODAL_TYPE, PAYMENT_MODE } from '../../muster/app/payments/constant';
import moment from 'moment';
import Label from '@dbk/ui-forms/src/label/label';
import Info2 from '@dbk/ui-icons/src/info-2';
import SuccessIcon from '../../components/common/icons/success-icon';
import PaymentRejectModal from './payment-reject-modal';
import MultisigPaymentStatusModal from './multisig-payment-status-modal'
import Priority from '@dbk/ui-icons/src/priority';
import { validateConfirmationAmount } from './payment-utils';
import { formatDayMonthYearHourMin } from '../../utils/date';
import Popover from '@dbk/ui-popover';


import { getPaymentReasonToDisplay } from '../../muster/app/payments/payment-utils';
const { PAYMENT } = ROUTES;

class PaymentSummary extends React.PureComponent {
  state = {
    showConfirmationModal: false,
    showCancelModal: false,
    showStatusModal: false,
    showExpireModal: false,
    showRejectModal: false,
    showMultisigRejectedStatusModal: false,
    multisigModalStatus: MODAL_TYPE.NONE,
    status: 'success',
    validRequest:true,
    confirmationAmount: "",
    isInputFieldTouched: false,
    isRefreshButtonClicked: false,
    showVopModal: false,
    isBenUpdateModal: false,
    showPatchFailedModal: false,
  }

  onDone = () => {
    const {payments: {isCashFlow,isCashPaymentFlow, currentTx:{signingType}} } = this.props;
    this.props.payments.resetForm();
    this.props.payments.setPosid('');
    
      if(isCashFlow) {
        if(isCashPaymentFlow){
        this.props.payments.setCreateNewModal(false)   //WMCE-41878- For disabling new create modal 
        this.props.payments.setFlowFalse(false);
        this.props.payments.setIsCashPaymentFlow(false);  //WMCE-49821- To enable arrow due to asyncronous behaviour
        this.props.payments.setDisableTabs(false);     //WMCE-41840- For enabling Menu bar
        this.props.changePage(ROUTES.CASH_ACCOUNTS.SUMMARY_CASH_ACCOUNTS_ROUTE);
        }
        else{
        this.props.payments.setCreateNewModal(false)   //WMCE-41878- For disabling new create modal 
        this.props.payments.setFlowFalse(false);
        this.props.portfolio.setAssetClassName('liquidity');
        this.props.changePage('/portfolios', true);
        this.props.payments.setDisableTabs(false);     //WMCE-41840- For enabling Menu bar
        this.props.changePage('/portfolios/genericAssets');
        }
    } else {
        if (signingType=== PAYMENT_MODE.MULTI && !this.state.isRefreshButtonClicked) {
          this.setState({showMultisigRejectedStatusModal: true, multisigModalStatus: MODAL_TYPE.CANCEL})
        }
        this.props.payments.setFlowFalse(false);
        localStorage.setItem('newPaymentComplete',true);
        // this.props.changePage(PAYMENT.DASHBOARD);
        this.setState({isRefreshButtonClicked: false})
      }
  }
  onModify = () => this.props.changePage(PAYMENT.NEW_DOMESTIC)
  onRefresh = () =>  {
    this.setState({isRefreshButtonClicked: true})
    this.props.payments.getRefreshStatus();
  }

  onConfirm = async () => {
    if(this.props.payments.isSaveEnabled)
      await this.props.payments.saveTemplate();
      await this.props.verifyChallengeResponse();
      this.toggleModal('showConfirmationModal',this.state.validRequest) ; 
  }

  onTimeout = () => this.cancelPayment(true, true)
  // * isNewPayment=true means a new created and valid payment from web,
  // * if false, meaning it is an existing payment from dashboard,
  cancelPayment = async (isNewPayment=false, timeout=false, cancelFromWeb=false, e) => {
    const {
      cancelTx,
      resetForm,
      cancelTxFails
    } = this.props.payments
    resetForm();
    if (isNewPayment) {
      if (timeout) {
        await cancelTx()
        this.setState({ showExpireModal: true })
      } else if (cancelFromWeb) {
        await cancelTx()
        this.setState({
          showStatusModal: false,
          status: 'reject'
        })
      } else {
        this.setState({
          showStatusModal: true,
          status: 'reject'
        })
        this.props.payments.setPaymentConfirmationStatus('reject')
        this.props.changePage(PAYMENT.PAYMENT_STATUS)


      }
    } else {
      await cancelTx()
      this.setState({
        showCancelModal: false,
        showStatusModal: false,
        status: 'reject'
      })
    }
  }

  failedPayment = () => {
    this.props.payments.setPaymentConfirmationStatus('failed')
    this.props.changePage(PAYMENT.PAYMENT_STATUS)
  }

  onRejectPayment = async (rejectReason) => {
    const { payments:{ onRejectTx} } = this.props;
    onRejectTx(rejectReason);
  } 
  onMultisigDone = () =>{
    this.setState({showMultisigRejectedStatusModal: false, multisigModalStatus: MODAL_TYPE.NONE});
    this.props.changePage(PAYMENT.DASHBOARD);
    this.props.payments.setRejectApiSuccess(false);

  }
  onMultigNewApproval = () => {
    this.props.changePage(PAYMENT.DASHBOARD);
    this.props.payments.setRejectApiSuccess(false);

  }
  donePayment = () => {
    const { app: { config: { isSepaIPEnabled: isSepaIPEnabledToUser } = {} }, payments: { selectedBeneficiaryBankSEPAPaymentType, currentTx: { executionDate } = {} } } = this.props;
    this.setState({
      showStatusModal: true,
      status: 'success'
    })
    this.props.payments.setPaymentConfirmationStatus('success')
    const isExecutionDateToday = executionDate ? moment(executionDate).isSame(moment(), 'day') : false;
    if (envConfig.envConfig === EBANKINGWEBLUX && isSepaIPEnabledToUser && selectedBeneficiaryBankSEPAPaymentType === SEPA_PAYMENT_TYPE.INSTANT && isExecutionDateToday) {
      this.props.payments.getSepaIpPaymentStatus();
    }
    this.props.changePage(PAYMENT.PAYMENT_STATUS)
  }
  goNewPayment = () => {
    this.props.payments.setCreateNewModal(true)
    this.onDone()
  }
  toggleModal = (modalName, status=true) => {
    this.setState({ [`${modalName}`]: status })
  }

  componentDidUpdate(){
    //payment status not updated when refresh button is clicked, 
    // so added this to update the status when refresh button is clicked when the returnCode is 101, 
    // which means the payment is expired and needs to be refreshed and show the expire modal
    if(this.props.payments?.refreshStatus?.returnCode === 101) {
       this.setState({
        showConfirmationModal: false,
        showExpireModal: true,
      })
    }
    if(document.querySelector('div.proceed')){
      document.querySelector('div.proceed').focus();
    }
    if(document.querySelector('button.btnPaymentDone')){
      document.querySelector('button.btnPaymentDone').focus();
    }
    if(document.querySelector('button.btnProceed')){
      document.querySelector('button.btnProceed').focus();
    }
  }

  async componentWillReceiveProps(nextProps) {
    if (nextProps.payments.isRequestInvalid === true ) {
      this.setState({
        validRequest: false,
        showStatusModal: true,
        status: 'terminate'
      })
      this.setState({ showConfirmationModal: false})
      this.props.payments.setPaymentConfirmationStatus('terminate')
        this.props.changePage(PAYMENT.PAYMENT_STATUS)

    }
  }
  componentWillUnmount() {
    this.props.payments.setErrorMsg(null);     //WMCE-12018- To remove error message when go back to payment form from payment summary
  }
  async componentWillReceiveProps(nextProps) {
    if (nextProps.payments.isRequestInvalid === true ) {
      this.setState({
        validRequest: false,
        showStatusModal: true,
        status: 'terminate'
      })
      this.setState({ showConfirmationModal: false})
      this.props.payments.setPaymentConfirmationStatus('terminate')
          this.props.changePage(PAYMENT.PAYMENT_STATUS)

    }
    if(nextProps.payments.isVopPatchSucceed === true) {
      this.setState({
        showVopModal: false,
        isBenUpdateModal: false,
      })
    }
    if(nextProps.payments.isVopPatchFailed === true) {
      this.setState({
        showVopModal: false,
        isBenUpdateModal: false,
        showPatchFailedModal: true,
      })
    }
  }

  handelVopModal = (flag) => {
    this.setState({
      showVopModal: flag,
      isBenUpdateModal: false,
    })
  }

  handelVopModalProceed = (verCode) => {
    const { payments: { beneficiariesNamesPatch } } = this.props;
    const { isBenUpdateModal } = this.state;
    if(isBenUpdateModal && verCode === VOP_VALIDATE_CODES.CLOSED_MATCH) {
      beneficiariesNamesPatch();
    } else {
      this.onConfirm();
    }
  }

  renderVopModal = (verCode) => {
    const { i18n: { messages }, payments: { isBenNamesPatching } } = this.props;
    const { showVopModal, isBenUpdateModal } = this.state;
    let contentText;
    
    switch(verCode) {
      case VOP_VALIDATE_CODES.CLOSED_MATCH: {
        if(isBenUpdateModal) {
          contentText = [messages["app.payments.vop.modal.closedMatch.update.msg"]];
        } else {
          contentText = [messages["app.payments.vop.modal.closedMatch.msg1"], messages["app.payments.vop.modal.closedMatch.msg2"]];
        }
      }
      break;
      case VOP_VALIDATE_CODES.NO_MATCH: {
        contentText = [messages["app.payments.vop.helptext.noMatch"], messages["app.payments.vop.modal.closedMatch.msg2"]];
      }
      break;
      case VOP_VALIDATE_CODES.VER_FAILED: {
        contentText = [messages["app.payments.vop.helptext.verFailed"], messages["app.payments.vop.modal.closedMatch.msg2"]];
      }
      break;
      default: {
        contentText = [messages["app.payments.vop.helptext.verFailed"], messages["app.payments.vop.modal.closedMatch.msg2"]];
      }
    }

    return(
      <Modal
        onClose={ () => this.handelVopModal(false) }
        isActive={showVopModal}
        header={ (verCode === VOP_VALIDATE_CODES.CLOSED_MATCH && isBenUpdateModal) ? messages["app.payments.vop.modal.closedMatch.header"] : messages["app.payments.vop.descModal.header"] }
        content={
          <View className="vop-modal-container">
            {
              contentText.map( msg => <View><Text>{msg}</Text></View>)
            }
            <View className="btn-container">
              <Button
                size="large"
                onPress={ () => this.handelVopModal(false) }
                tertiary
              >
                {messages["app.payments.summary.cancel"]}
              </Button>
              <Button
                size="large"
                onPress={ () => this.handelVopModalProceed(verCode) }
                loading = { verCode === VOP_VALIDATE_CODES.CLOSED_MATCH && isBenNamesPatching ? true : false }
              >
                { verCode === VOP_VALIDATE_CODES.CLOSED_MATCH && isBenUpdateModal 
                  ? messages["app.trade.label.proceed"] 
                  : messages["app.payment.vop.modal.btn.proceedAnyway"] }
              </Button>
            </View>
          </View>
        }
      />
    )

  }

  handleVopClosedMatch = (e) => {
    if(isEnterorSpaceKeyPressed(e)) {
      this.setState({
        isBenUpdateModal: true,
        showVopModal: true,
      });
    }
  }

  handlePatchFailedModal = (flag) => {
    this.setState({
      showPatchFailedModal: flag,
    })
  }

  renderPatchFailedModal = () => {
    const { i18n: { messages } } = this.props;
    const { showPatchFailedModal } = this.state;
    return(
      <Modal
        onClose={ () => this.handlePatchFailedModal(false) }
        isActive={ showPatchFailedModal }
        header={ messages["app.payments.vop.descModal.header"] }
        content={
          <View className="vop-modal-container">
            <View className="desc-container">
              <AttentionDarkIcon/>
              <Text className="desc-container__text">{messages["app.payments.vop.modal.patchFailed.desc"]}</Text>
            </View>
            <View className="btn-container">
              <Button
                size="large"
                onPress={ () => this.handlePatchFailedModal(false) }
              >
                {messages["app.rmcallback.okMsg"]}
              </Button>
            </View>
          </View>
        }
      />
    )
  }


  getStatusMsg = (status) => {
      const {
      i18n: { messages }} = this.props
    // code commented as part of multisig code for phase 2

    let statusText = '';
    switch (status) {
      case MULTISIGN_PAYMENT_STATUS.PENDING_APPROVAL:
        statusText =messages['app.payments.multisig.submittedBy']
        break 
      case MULTISIGN_PAYMENT_STATUS.PARTIALLY_APPROVED:
        statusText = messages['app.payments.multisig.submittedBy']
        break
      case MULTISIGN_PAYMENT_STATUS.APPROVED:
        statusText = messages['app.payments.multisig.approvedBy']
        break
      case MULTISIGN_PAYMENT_STATUS.REJECTED:
        statusText = messages['app.payments.multisig.rejectedBy']
        break
      case MULTISIGN_PAYMENT_STATUS.DISCARDED:
        statusText = messages['app.payments.multisig.discardedBy']
        break
      case MULTISIGN_PAYMENT_STATUS.EXPIRED:
        statusText = messages['app.payments.multisig.expiredBy']
        break
      case MULTISIGN_PAYMENT_STATUS.ABORTED:
        statusText = messages['app.payments.multisig.aborted']
        break
      case MULTISIGN_PAYMENT_STATUS.RULES_CHANGED:
        statusText = messages['app.payments.multisig.aborted']
        break
      default:
        break 
    }
     return statusText
  }

  checkExpiredAbortedStatusCode = (status) => {
    return (status === MULTISIGN_PAYMENT_STATUS.ABORTED || status=== MULTISIGN_PAYMENT_STATUS.RULES_CHANGED || status === MULTISIGN_PAYMENT_STATUS.EXPIRED)
  }
  getApproverHistoryStatusMap = () => {
    const {
      i18n: { messages },
      payments: { currentTx: { approvalHistory}}} = this.props
    return approvalHistory.map(res => {
      const statusText= this.getStatusMsg(res.signingStatusCode);
      return (<div className="margin-bottom-5" tabIndex={0}>
        <Text secondary className="margin-right-5">{statusText}</Text>
        {res.userId && !this.checkExpiredAbortedStatusCode(res.signingStatusCode) && 
        (<Text className="margin-right-5">{res.userId}</Text>)}
        <Text secondary className="margin-right-5">{messages['app.payments.multisig.onDate']}</Text>
        <Text>{ formatDayMonthYearHourMin(res.changedAtTs) }</Text>
        {(res.signingStatusCode === MULTISIGN_PAYMENT_STATUS.ABORTED  || res.signingStatusCode === MULTISIGN_PAYMENT_STATUS.RULES_CHANGED) && (<Text>{ messages['app.payments.multisig.rulesChanged'] }</Text>)}
      </div>)
    })
  
  }
  getRejectReason = () => {
    const {
      i18n: { messages },
      payments: { currentTx: { rejectionReason}}} = this.props
      return (<div className="margin-bottom-5" tabIndex={0}>
        <Text secondary className="margin-right-5">{messages['app.payments.multisig.rejectDialogSubheader'] + ':'}</Text>
        <Text className="margin-right-5">{rejectionReason || '-'}</Text>
      </div>)
  
  }

  resumeMultisignPayment = () => {
    this.props.payments.resumeMultisignPayment();
  }

  handleChangeAmountConfirmation = data => {
    if (typeof data === 'object') {
      const {
        target: { value }
      } = data

      const regex = new RegExp("^\\d+(\\.\\d{0,2}|)$");

      if (regex.test(value) || value == "")
        this.setState({ confirmationAmount:value })
    } else {
      this.setState({ confirmationAmount:data })
    }
  }

  isMultiSigApprovalExpMsgEnabled = (statusCode) => {
    return statusCode === MULTISIGN_PAYMENT_STATUS.REJECTED 
            || statusCode === MULTISIGN_PAYMENT_STATUS.ABORTED
            || statusCode === MULTISIGN_PAYMENT_STATUS.EXPIRED
            || statusCode === MULTISIGN_PAYMENT_STATUS.APPROVED
            || statusCode === MULTISIGN_PAYMENT_STATUS.RULES_CHANGED;
  }

  render () {
    const {
      i18n: { messages },
      payments: {
        initializeTxFails,
        isValidatingPayment,
        isFetchingTx,
        transactionId,
        tppName,
        isModifyFlow,
        remarks,
        isMultiSigApprovalFlow,
        isMultiSigViewOnlyFlow,
        isLoading,
        cancelTxLoading,
        isRejectApiSuccess,
        setRejectApiSuccess,
        isApprovalFlowLockedByUser,
        selectedBeneficiaryBankSEPAPaymentType,
        cancelTxFails,
        cancelTxFailMsg,
        currentTx: {
          orderId,
          accName,
          bpName,
          accNo,
          pfId,
          accBal,
          accBalCode,
          asOfDate='',
          beneficiaryName,
          address1,
          address2,
          address3,
          ibanNo,
          bankName,
          swiftCode,
          currencyAmount,
          currencyAmountCode,
          executionDate='',
          valueDate,
          costs,
          status,
          editable,
          cancelable,
          confirmable,
          externalOrderId,
          ntnlId,
          sortCode,
          transactionFee,
          forexText,
          signingType,
          approvalExpiryTs,
          approvalHistory,
          statusCode
        },
        paymentType,
        refreshStatus,
        errorMsgs,
        selectedDebitAcnt,
        selectedBeneficiaryBank,
        selectedBeneficiaryDetail,
        vopValVerCode,
        vopValPayeeName,
      },
      auth: { paymentSubmitDisabled },
      app: { config: { isSepaIPEnabled, isVopEnabled } },
    } = this.props
    const vopAllowed = isVopAllowed(isVopEnabled, paymentType);
    
    let paymentReasonToDisplay = getPaymentReasonToDisplay(this.props.payments.paymentReasonList, this.props.payments.paymentReason);
    if (isValidatingPayment || isFetchingTx)
      return <div className="spinnerPosition"><Spinner size="large"/></div>
    if (initializeTxFails || cancelTxFails) {
      let msg = (errorMsgs && errorMsgs[0].errorDesc) ? errorMsgs[0].errorDesc : messages['app.payments.failToConnect']
      if (initializeTxFails==='acp.down') {
        msg = messages['app.payment.error.acp.down']
      }
      if (cancelTxFails)  msg = cancelTxFailMsg
      return (
        <Modal
          isActive
          onClose={() => this.props.changePage(PAYMENT.DASHBOARD)}
          className={"model-window-login"}
          content={
            <div className="small-12 row" style={{paddingBottom: '20px', paddingTop: '10px'}}>
              <div className="column small-2">
                <ErrorIcon width={30} height={30} />
              </div>
              <div className="column small-10" role="alert" tabIndex={0} aria-label={msg}>
                <Text secondary>{msg}</Text>
              </div>
            </div>
          }
        />
      )
    }
    let transactionDtsForAdvice;
    if(this.props.payments.currentTx && this.props.payments.selectedDebitAcnt){
      transactionDtsForAdvice = {
        posId: selectedDebitAcnt.psPosId,
        transactionDate:this.props.payments.currentTx.executionDate,
        transactionNo: this.props.payments.currentTx.externalOrderId,
      }
    }
    // close dialog when reject api success and show status modal
    if (isRejectApiSuccess){
      this.setState({showMultisigRejectedStatusModal: true, multisigModalStatus: MODAL_TYPE.REJECT, showRejectModal: false})
    }
    
    const {
      showConfirmationModal,
      showCancelModal,
      showStatusModal,
      showExpireModal,
      showRejectModal,
      showMultisigRejectedStatusModal
    } = this.state
    // todo: for internal transfer
    const isInternal = paymentType.includes('internal')
    const isDomestic = paymentType.includes('domestic')
    const isSepa = paymentType.includes('sepa');
    const isUKRegion = (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK);
    const isLuxSepaIPAllowed = isSepaIPEnabled && envConfig.envConfig === EBANKINGWEBLUX;
    const showCosts = !(paymentType.includes('internal') || paymentType.includes('sepa') || isUKRegion)
    const isInternational = paymentType.includes(PAYMENT_TYPE.international);
    let pageTitle = messages['app.payment.pageTitle.summaryDomestic']
    let swiftOrNtnlId = ntnlId?(' ('+ntnlId+')') : ''
    if (paymentType === "international-payments") {
      pageTitle = messages['app.payment.pageTitle.summaryInternational']
      swiftOrNtnlId = swiftCode?(' ('+swiftCode+')') : ''
    } else if(paymentType === "sepa-payments") {
      pageTitle = messages['app.payment.pageTitle.summarySepa']
      swiftOrNtnlId = swiftCode?(' ('+swiftCode+')') : ''
    } else if(paymentType === "internal-payments") {
      pageTitle = messages['app.payment.pageTitle.summaryInternal']
      swiftOrNtnlId = ' ' + swiftCode
    }else if(paymentType === "swissqrbill-payments") {
      pageTitle = messages['app.payment.pageTitle.summaryQRBillPayment']
      swiftOrNtnlId = ' ' + swiftCode
    }
    const bankSwift = swiftOrNtnlId
    const fmtAsOfDate = asOfDate && asOfDate.length===10? format(new Date(asOfDate), 'dd MMM yyyy') : asOfDate
    let fmtValueDate = '' // if valueDate null
    if (valueDate) {
      fmtValueDate = valueDate.length===10?format(new Date(valueDate), 'dd MMM yyyy'):valueDate
    }
    let fmtExecutionDate = ''
    if (executionDate) {
      fmtExecutionDate = executionDate.length===10?format(new Date(executionDate), 'dd MMM yyyy'): executionDate
    }

    let checkSortCode = sortCode ? sortCode : ntnlId;

    let sortCodeFormat= (checkSortCode && typeof(checkSortCode) === 'string') ? checkSortCode : (checkSortCode && typeof(checkSortCode) === 'number') ? checkSortCode.toString() : '';
    if(checkSortCode && sortCodeFormat.length === 6){
      sortCodeFormat = `${sortCodeFormat.slice(0,2)}-${sortCodeFormat.slice(2,4)}-${sortCodeFormat.slice(4,6)}`
    }else{sortCodeFormat=''}
    const accountNameDisplayValue = bpName || (selectedDebitAcnt && selectedDebitAcnt.bpName);
    // currentTx.ibanNo belongs to the beneficiary ("to") account, so the from account's own IBAN must come from selectedDebitAcnt
    const fromIbanNo = (selectedDebitAcnt && selectedDebitAcnt.ibanNo) || accNo;
    // currentTx never carries city/country; selectedBeneficiaryBank/selectedBeneficiaryDetail do (same source payment-form.js reads)
    const toBeneficiaryAccount = selectedBeneficiaryBank || selectedBeneficiaryDetail;
    const toCity = toBeneficiaryAccount && (toBeneficiaryAccount.city || toBeneficiaryAccount.cityName);
    const toCountry = toBeneficiaryAccount && toBeneficiaryAccount.country;
      
    return (
      <div className="payment-page payment-summary row form-bottom">
       {errorMsgs && <PaymentError errors={errorMsgs} aria-label={errorMsgs}/>}
        <div className="title" id="title_paymentSummary_test">
          <H1 tabIndex={0}>{pageTitle}</H1>
        </div>
        <div className="payment-summary-container payment-mask-bg">
          <div className="row">
          <div id='domestic-summary-to' className="columns small-12 medium-6" >
              <div tabIndex={0} className="to-from-container">
                <Text secondary size="big">{messages['app.payments.summary.to']}</Text>
              </div>
              <div>
                <div align="left" >
                <div tabIndex={0}>
                  <Text secondary>{`${messages['app.pymt.summary.to']}: `}</Text>
                    <Text className="word-break">{beneficiaryName}</Text>
                </div>
                {
                  ( vopAllowed && vopValVerCode &&
                    <View className="vop-helptext-container">
                      { 
                        (vopValVerCode == VOP_VALIDATE_CODES.CLOSED_MATCH) ?
                        (<View className="helptext">
                          <WarningDarkIcon/>
                          <View className="helptext__text">
                            <FormattedMessage
                              id="app.payments.vop.helptext.closedMatch"
                              values={{ Exact_Name: <Text secondary role="link" tabIndex={0} aria-label={vopValPayeeName} onKeyDown={ (e) => this.handleVopClosedMatch(e) } className='helptext__text--sub-text cursor-pointer' onClick={ () => this.handleVopClosedMatch() }>{vopValPayeeName}</Text> }}
                            >
                              { text => <Text type="warning">{text}</Text>}
                            </FormattedMessage>
                          </View>
                        </View>) :
                        (<Helptext verCode={vopValVerCode} messages={messages}/>)
                      } 
                      <HelptextDescription/>
                    </View>
                  )
                }
                
                  { (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && paymentType.includes('domestic') ?
                    <div>
                          {ibanNo ?  
                            <div tabIndex={0}>
                              <Text secondary>{`${messages['app.incomehistory.accNum']} `}</Text>
                              <Text>{ibanNo}</Text>
                            </div>
                          : 
                          <div tabIndex={accNo ? 0 : -1}>
                            { accNo && <div><Text secondary>{`${messages['app.incomehistory.accNum']} `}</Text>
                              <Text>{accNo}</Text></div>
                            }
                          </div>}
                          <div tabIndex={(bankName || checkSortCode) ? 0 : -1}>
                            { (bankName || checkSortCode) && <div><Text secondary>{`${messages['app.payments.summary.bank']}: `}</Text>
                            <Text>{bankName && bankName} {checkSortCode && sortCodeFormat}</Text></div>
                            }
                          </div>


                          {/* <div tabIndex={(bankName || checkSortCode) ? 0 : -1}><Text>{bankName && bankName} {checkSortCode && sortCodeFormat}</Text></div> */}
                    </div>
                    :
                    <div>
                          <div tabIndex={0}>
                            <Text secondary>{`${messages['app.incomehistory.accNum']} `}</Text>
                            <Text>{ibanNo}</Text>
                          </div>
                          <div tabIndex={(isInternal || bankName || bankSwift) ? 0 : -1}>
                            { isInternal ? <div><Text secondary>{`${messages['']}: `}</Text>
                              <Text>{bankSwift}</Text></div> :
                              bankName && <div><Text secondary>{`${messages['app.payments.summary.bank']}: `}</Text>
                              <Text>{bankName && bankName}{bankSwift ? ` ${bankSwift}` : ''}</Text></div>
                            }
                          </div>
                    </div>
                  }
                  {(toCity || toCountry) &&
                    <div tabIndex={0}>
                      <Text>{toCity}{toCity && toCountry ? ', ' : ''}{toCountry}</Text>
                    </div>}
                </div>
              </div>
            </div>
            <div id='domestic-summary-from' className="columns small-12 medium-6">
              <div tabIndex={0} className="to-from-container">
                <Text secondary size={"big"}>{messages['app.payments.summary.from']}</Text>
              </div>
              <div className="from-section">
                <div className="account-detail">
                {accountNameDisplayValue && <div tabIndex={0}>
                  <Text secondary>{`${messages['app.common.portfolio.bonds.account']}: `}</Text>
                  <Text>{accountNameDisplayValue}</Text>
                </div>}
                <div tabIndex={0}>
                  <Text secondary>{`${messages['app.payment.account.name']}: `}</Text>
                  <Text>{accName}</Text>
                </div>
                  <div tabIndex={0} aria-label={labelForPFid(fromIbanNo)}>
                    <Text secondary>{`${messages['app.common.portfolio.accountIban']}: `}</Text>
                    <Text>{fromIbanNo}</Text>
                    </div>
                  <div tabIndex={0} aria-label={messages['app.payments.portfolio.text']+" "+labelForPFid(pfId)}>
                    <Text secondary>{`${messages['app.payments.portfolio.text']}: `}</Text>
                    <Text>{pfId}</Text>
                  </div>
                </div>
                <div className="asOf-section">
                  <div tabIndex={0}>
                    <Text secondary>{`${messages['app.common.portfolio.bonds.balance']} `}</Text>
                    <Currency
                      currency={accBalCode}
                      value={accBal}
                      renderProps={{
                        size: 'small',
                        style: styles.dateStyle
                      }}
                    />
                  </div>
                  <div>
                    <div tabIndex={0} className='asOfDate'>
                   { (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) ? <Small secondary>{messages['app.payment.asOfToday']}</Small> 
                   : 
                   <React.Fragment>
                    <Small secondary className="margin-right-5">{messages['app.payments.asOfDate']}</Small>
                    <Small>{fmtAsOfDate}</Small>
                    </React.Fragment>}
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
          <div className="row">
          {/* Fix for WMCE-12376 - removed istemplateflow check */}
          {this.props.payments.isSaveEnabled && 
          <div id='domestic-summary-from' className="columns small-12 medium-6">
              <div align="left">
              <div className='checkBoxContainer'>
                <Checkbox
                  disabled
                  title={messages['app.payment.templates.saveCheckbox.title']}
                  checked={this.props.payments.isSaveEnabled}
                  className = "checkBoxStyle"/>
                <div tabIndex={0}>
                  <Text disabled >{messages['app.payment.templates.saveCheckbox.title']}</Text>
                </div>
              </div>
                <div className="margin-top-10" tabIndex={0}>
                  <Text secondary size={"big"}>{messages['app.payment.templates.templateName']}</Text>
                </div> 
                <div className="margin-top-5" tabIndex={0}>
                  <Text>{this.props.payments.templateName}</Text>
                </div>
              </div>
          </div>}
            <div id='domestic-summary-details' className="columns small-12 medium-6">
              <div tabIndex={0} className="to-from-container">
                <Text secondary size={"big"}>{messages['app.payments.summary.paymentDetails']}</Text>
              </div>
              <div>
                <div align="left">
                  <div tabIndex={0}>
                    <Text secondary>{`${messages['app.payments.summary.amount']} `}</Text>
                    <Currency value={currencyAmount?parseFloat(currencyAmount):null} currency={currencyAmountCode} renderProps={{ size: 'small', style: styles.dateStyle }} />
                  </div>
                </div>
                <div tabIndex={0}>
                  <Text secondary>{`${messages['app.payments.summary.execDate']} `}</Text>
                  <Text>{fmtExecutionDate}</Text>
                </div>
                <div tabIndex={0}>
                  <Text secondary>{`${messages['app.payments.summary.valueDate']} `}</Text>
                  <Text>{fmtValueDate}</Text>
                </div>
                {showCosts &&
                  <div tabIndex={0}>
                    <Text secondary>{`${messages['app.payments.summary.costs']} `}</Text>
                    <Text>{costs}</Text>
                  </div>}
                <div tabIndex={0}>
                  <Text secondary>{`${messages['app.payments.summary.paymentStatus']} `}</Text>
                  <Text>{status}</Text>
                </div>
                {isSepa && isLuxSepaIPAllowed && <div tabIndex={0}>
                  <Text secondary>{`${messages['app.payments.summary.instantPayment']} `}</Text>
                  <span className="instant-payment-value">{selectedBeneficiaryBankSEPAPaymentType === SEPA_PAYMENT_TYPE.INSTANT ? messages['app.common.alert.yes'] : messages['app.common.alert.no']}</span>
                </div>}
                {externalOrderId &&
                  <div tabIndex={0}>
                    <Text secondary>{`${messages['app.payments.summary.referenceNumber']} `}</Text>
                    <Text>{externalOrderId}</Text>
                  </div>}                  
                {(envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && this.props.payments.paymentReason &&
                  <div tabIndex={0}>
                    <Text secondary>{`${messages['app.payment.reason']}: `}</Text>
                    <Text>{paymentReasonToDisplay}</Text>
                  </div>}
                {remarks && 
                  <div tabIndex={0}>
                    <Text secondary>{ (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) ? `${messages['app.payment.additional.information']}: ` : `${messages['app.payment.additional.beneficiary.information']}: ` }</Text>
                    <Text>{remarks}</Text>
                  </div>}
                  
                  {/* {(envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && !editable && !isModifyFlow && confirmable && <div>
                    
                    <Text secondary>{`${messages['app.payments.feeForTransactions']}`}</Text>&nbsp;
                    { costs && (costs === ALL_CHARGES_EN || costs === ALL_CHARGES_DE)&& <Text secondary>{`${messages['app.payments.fee.transaction.thirdPartyExpense']}`}</Text>}
                    
                  </div>} */}
                  { (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && forexText !== null && !editable && confirmable && !cancelable && <div tabIndex={0}><Text secondary>{forexText}</Text></div>}

                  <div>&nbsp;</div>
                  { (isInternational) && (envConfig.envConfig === EBANKINGWEBLUX) && <div tabIndex={0}><Text>{messages['app.psd2.payment.excute.xchngeLabel']}</Text></div>}
              </div>
            </div>
         

          {/* approval history start*/}
            {(isMultiSigApprovalFlow || isMultiSigViewOnlyFlow) && (<div className="approval-history columns small-12 medium-6">
              <div className='container margin-top-0' tabIndex={0}>
                <Text secondary size={'big'} >{messages['app.payments.multisig.approvalHistory']}</Text>
              </div>
             { approvalHistory && this.getApproverHistoryStatusMap()}
             {statusCode?.toUpperCase() === PAYMENT_STATUS.REJECTED && this.getRejectReason()}

            </div>)}
            {/* approval history end*/}

             {/* section for multi payment to show approval period expiry 
            will not be shown for blocking errors*/}
            {(signingType=== PAYMENT_MODE.MULTI || isMultiSigApprovalFlow || isMultiSigViewOnlyFlow)  && !this.isMultiSigApprovalExpMsgEnabled(statusCode) && 
            (<div className="approval-exp columns small-12 medium-6" tabIndex={0}>
              <span className='margin-right-5'><Priority color= {PALETTE.warning}></Priority></span>
              <Text type="warning">{messages["app.payments.summary.approvalExpDate"]} {formatDayMonthYearHourMin(approvalExpiryTs)}
                </Text>

            </div>)}

            </div>
          
            
          
          {transactionId && !cancelable && !editable &&
            <div tabIndex={0} style={{display:'flex', flexDirection:'row-reverse', paddingRight:'15px',paddingTop:'10px'}}>
              <Text secondary>{messages['app.psd2.payment.noCancelPayment']}{tppName}</Text>
            </div>
          } 
          </div> 

        <div className='payment-btn-block medium-6 medium-offset-6'>

            {isMultiSigApprovalFlow && confirmable && <React.Fragment>
            
             <Popover
                mode="popup"
                orientation="top"
                showOnHover
                popOverClassName="cur-bal-popover"
                arrowColor={PALETTE.secondaryActive}
                content={<div>{messages['app.payments.multisig.popoverMessage']}</div>}
              >
              <div aria-label={messages['app.dashboard.toolTip'] + " " + messages['app.payments.multisig.popoverMessage']}>
                <Info2 color={PALETTE.fordGray} height={POPOVER_ICON_SIZE.HEIGHT} width={POPOVER_ICON_SIZE.WIDTH}/>
              </div>
              </Popover>
            <div className="amtConfirmationBlock">
              <TextInput
                ref='textRef'
                className="amountConfirmationInput"
                maxLength={35}
                required
                label={messages['app.payments.multisig.amountConfirmation']}
                success={this.state.isInputFieldTouched && validateConfirmationAmount(this.state.confirmationAmount, currencyAmount)}
                error={this.state.isInputFieldTouched && !validateConfirmationAmount(this.state.confirmationAmount, currencyAmount)}
                onBlur={() => this.setState({isInputFieldTouched:true})}
                onChange={this.handleChangeAmountConfirmation}
                value={this.state.confirmationAmount}
              />

              {this.state.isInputFieldTouched && (validateConfirmationAmount(this.state.confirmationAmount, currencyAmount) ? (
                <div className='amtMatchMismatchContainer' tabIndex={0}>
                  <SuccessIcon className="margin-right-5" color={PALETTE.successIcon} height={20} width={20} />
                  <span className='match'>{messages['app.payments.multisig.amtMatch']}</span>
                </div>
              ) : (
                <div className='amtMatchMismatchContainer' tabIndex={0}>
                  <Info className="margin-right-5" color={PALETTE.errorColor} height={20} width={20} />
                  <span className='mismatch'>{messages['app.payments.multisig.amtMismatch']}</span>
                </div>
              ))}
            </div>
          </React.Fragment>}

            {signingType !== PAYMENT_MODE.MULTI  && (<div className='adviceBtn payment-btn'>
              <TransactionSecurityAdvice
              tertiary={ editable || confirmable || cancelable }
              isPaymentAdviceAvailble
              transaction={transactionDtsForAdvice}/>
            </div>)}
            {paymentSubmitDisabled && !editable && !cancelable && confirmable &&
              <div className='payment-btn-block medium-6 medium-offset-6'>
                <div className='adviceBtn payment-btn'>
                  <Button
                  testID="btn_confirmBtn_paymentSummary_test"
                  size="large"
                  onPress={this.goNewPayment} >
                  {messages['app.rmAccess.payments.button.newPayment']}
                  </Button>
                </div>

                <div className='adviceBtn payment-btn'>
                  <Button
                    testID="btn_confirmBtn_paymentSummary_test"
                    size="large"
                    onPress={this.onDone} >
                    {messages['app.rmAccess.payments.button.done']}
                  </Button>
                  </div>
              </div>
            }

            {/* ----------Initiator flow buttons start----------
            if it is inititator flow, isMultiSigApprovalFlow will be false and 
            isMultiSigViewOnlyFlow will be false */}
            {
            !isMultiSigApprovalFlow && !isMultiSigViewOnlyFlow && (
            <React.Fragment>
              {cancelable &&
              <div className='adviceBtn payment-btn'>
                  <Button
                  testID="btn_cancelBtn_paymentSummary_test"
                  tertiary size="large"
                  disabled={transactionId ? true : false}
                  onPress={() => this.toggleModal('showCancelModal')} >
                  {orderId? messages['app.manageContactDetails.delete'] : messages['app.payments.summary.discard']} 
                  </Button>
              </div>
              }
              {editable &&
              <div className='adviceBtn payment-btn'>
                  <Button
                    testID="btn_modifyBtn_paymentSummary_test"
                    size="large"
                    onPress={this.onModify} 
                    secondary
                    disabled={transactionId ? true : false}>
                  {messages['app.payments.summary.modify']}
                  </Button>
              </div>
              }
              {confirmable && !paymentSubmitDisabled &&
              <div className='adviceBtn payment-btn margin-right-0'>
                  <Button
                  testID="btn_confirmBtn_paymentSummary_test"
                  size="large"
                  tertiary = {paymentSubmitDisabled}
                  disabled = {signingType=== PAYMENT_MODE.MULTI ? paymentSubmitDisabled && !validateConfirmationAmount(this.state.confirmationAmount, currencyAmount) : paymentSubmitDisabled}
                  onPress={ 
                  (vopAllowed && vopValVerCode && vopValVerCode !== VOP_VALIDATE_CODES.FULL_MATCH)
                    ? () => this.handelVopModal(true)
                    : this.onConfirm
                  }>
                  {signingType=== PAYMENT_MODE.MULTI ? messages['app.payments.summary.submitForApproval'] : messages['app.payments.summary.confirm']}
                  </Button>
              </div>
              }
              
            </React.Fragment>
            )}
            {/* ----------initiator flow buttons end---------- */}




            {/* ----------Multi-sig approval flow buttons start ; 
            isMultiSigApprovalFlow will be true and isMultiSigViewOnlyFlow will be false ---------- */}
            {
            isMultiSigApprovalFlow && !isMultiSigViewOnlyFlow && (
              <React.Fragment>
                <div className='adviceBtn payment-btn'>
                  <Button
                    testID="btn_cancelBtn_paymentSummary_test"
                    tertiary size="large"
                    disabled={transactionId ? true : false}
                    onPress={() => this.toggleModal('showRejectModal')} >
                    {messages['app.payments.summary.reject']}
                  </Button>
                </div>
                {!editable && !cancelable && confirmable && (<div className='adviceBtn payment-btn margin-right-0'>
                  <Button
                    testID="btn_confirmBtn_paymentSummary_test"
                    size="large"
                    tertiary = {paymentSubmitDisabled}
                    disabled = { !validateConfirmationAmount(this.state.confirmationAmount, currencyAmount)}
                    onPress={this.onConfirm} >
                    {messages['app.payments.multisig.approve']}
                  </Button>
                </div>)}
              </React.Fragment>
            )}
            {/* Multisig approval flow button ends */}

            {/* ----------Multi-sig view only flow buttons start ; */}
            {
            isMultiSigViewOnlyFlow && (
              <React.Fragment>
                {isApprovalFlowLockedByUser && (<div className='adviceBtn payment-btn margin-right-0'>
                  <Button
                    testID="btn_cancelBtn_paymentSummary_test"
                    secondary size="large"
                    onPress={() => { this.resumeMultisignPayment()}} >
                    {messages['app.payments.multisig.resumeApproval']}
                  </Button>
                </div>)}
                <div className='adviceBtn payment-btn margin-right-0'>
                  <Button
                    testID="btn_cancelBtn_paymentSummary_test"
                    tertiary size="large"
                    onPress={() => { this.props.goBack();this.props.payments.resetTemplateVariables()}} >
                    {messages['app.payments.multisig.back']}
                  </Button>
                </div>
                
              </React.Fragment>
            )}
          {/* ----------Multi-sig view only flow buttons end---------- */}  


        </div>  

        
       {showRejectModal && <PaymentRejectModal
        messages={messages}
        isLoading={isLoading}
        onRejectDone={this.onRejectPayment}
        onCancel={() => this.toggleModal('showRejectModal', false)}
        />}

        {/* modal for multisig reject and cancel */}
        {showMultisigRejectedStatusModal && 
        <MultisigPaymentStatusModal 
        onConfirm={() =>this.onMultigNewApproval()}
        messages={messages}
        isMultiSigApprovalFlow={isMultiSigApprovalFlow}
        status={this.state.multisigModalStatus}
        onDone={() => this.onMultisigDone()}/>}

        {showConfirmationModal &&
        <ConfirmationModal
          messages={messages}
          orderId={orderId}
          refreshStatus={refreshStatus}
          cancelPayment={this.cancelPayment}
          donePayment={this.donePayment}
          onRefresh={this.onRefresh}
          isMultisigFlow ={signingType === PAYMENT_MODE.MULTI}
          isInitiatorFlow={!isMultiSigApprovalFlow}                
          onCancel={() => this.toggleModal('showCancelModal')}
          onTimeout={this.onTimeout}
          failedPayment={this.failedPayment}
        />}
        {showCancelModal &&
        <CancelModal
          messages={messages}
          onConfirm={(e) => this.cancelPayment(!orderId, false, true, e)}
          onCancel={() => this.toggleModal('showCancelModal', false)}
          order={orderId}
          isLoading={cancelTxLoading}
          isMultisigFlow ={signingType === PAYMENT_MODE.MULTI}
          isInitiatorFlow={!isMultiSigApprovalFlow}                
          isModifyFlow={isModifyFlow}
          onDone={this.onDone}
        />}
        {/* {showStatusModal &&
        <StatusModal
          status={this.state.status}
          execDate={executionDate}
          messages={messages}
          onDone={this.onDone}
          isMultisigFlow ={signingType === PAYMENT_MODE.MULTI}
          isInitiatorFlow={!isMultiSigApprovalFlow}
          onNewPayment={this.goNewPayment}
        />} */}
        {showExpireModal &&
        <Modal
          isActive
          hideCloseButton
          disableOutsideClick
          title={messages['app.warning.text']}
          onClose={() => {this.onDone(); this.props.changePage(PAYMENT.DASHBOARD);}}
          header={messages['app.warning.text']}
          className={"model-window-login"}
          content={
            <div className="payment-expired-modal">
              <div className="padding-20" tabIndex={0}>
                <Text>{messages['app.payment.error.expired']}</Text>
              </div>
              <div className="modal-footer">
                <div className="okButton margin-bottom-10 margin-right-20">
                  <div className="payment-btn">
                    <Button size={"large"} fullWidth onPress={() => { this.onDone(); this.props.changePage(PAYMENT.DASHBOARD);}}>
                      {messages['app.rmcallback.okMsg']}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          }/>
        }
        {this.renderVopModal(vopValVerCode)}
        { this.renderPatchFailedModal() }
      </div>
    )
  }
}

export default createContainer({
  $queries: {
    i18n: { messages: true, },
    changePage: { $call: 'ui.history.push' },
    payments: {
      isValidatingPayment: true,
      isFetchingTx: true,
      initializeTxFails: true,
      isModifyFlow: true,
      remarks: true,
      loading: true,
      currentTx: true,
      refreshStatus : true,
      errorMsgs: true,
      cancelTxLoading: true,
      paymentReason: true,
      isMultiSigApprovalFlow: true,
      isMultiSigViewOnlyFlow: true,
      initializeTx: { $call: 'initializeTx' },
      cancelTx : { $call: 'cancelTx'},
      onRejectTx : { $call: 'rejectTx'},
      resetForm: { $call: 'resetForm'},
      getRefreshStatus: { $call: 'getPaymentStatus' },
      setCreateNewModal: { $set: 'createNewModal' },
      paymentType: true,
      isCashFlow: true,
      setFlowFalse: { $set: 'isCashFlow' },
      isCashPaymentFlow: true,
      setIsCashPaymentFlow: { $set: 'isCashPaymentFlow' },
      setPosid: { $set: 'psPosId' },
      selectedDebitAcnt: true,
      selectedBeneficiaryBank: true,
      selectedBeneficiaryDetail: true,
      isSaveEnabled: true,
      saveTemplate: {$call: 'saveUpdateTemplate'},
      templateName: true,
      transactionId:true,
      tppName:true,
      isRequestInvalid : true,
      setErrorMsg: { $set: 'errorMsgs' },
      isRequestInvalid : true,
      disableTabs:true,
      isRejectApiSuccess: true,
      setRejectApiSuccess: {$set : 'isRejectApiSuccess'},
      setDisableTabs: { $set: 'disableTabs'},
      resetTemplateVariables: { $call: 'resetTemplateVariables'},
      vopValVerCode: true,
      vopValPayeeName: true,
      isBenNamesPatching: true,
      beneficiariesNamesPatch: { $call: 'beneficiariesNamesPatch' },
      getSepaIpPaymentStatus: { $call: 'getSepaIpPaymentStatus' },
      isVopPatchFailed: true,
      isVopPatchSucceed: true,
      paymentReasonList: true,
      isApprovalFlowLockedByUser: true,
      resumeMultisignPayment: { $call: 'resumeMultisignPayment'},
      selectedBeneficiaryBankSEPAPaymentType: true,
      paymentConfirmationStatus: true,
      setPaymentConfirmationStatus: { $set: 'paymentConfirmationStatus' },
      cancelTxFails: true,
      cancelTxFailMsg: true,
    },
    verifyChallengeResponse: { $call: 'payments.verifyChallengeResponse' },
    portfolio: {
        setAssetClassName: { $set: 'assetClassName' }
    },
    auth: { paymentSubmitDisabled: true },
    goBack: { $call: 'ui.history.goBack' },

    app: {
      config: {
        isSepaIPEnabled: true,
        isVopEnabled: true
      }
    },
  },
})(PaymentSummary);
